import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    timeout: Number,
    hiddenClass: { type: String, default: "opacity-0" }
  }

  connect() {
    if (!this.timeoutValue || this.timeoutValue <= 0) return

    this.timer = window.setTimeout(() => this.dismiss(), this.timeoutValue)
  }

  disconnect() {
    if (this.timer) {
      window.clearTimeout(this.timer)
      this.timer = null
    }
  }

  dismiss() {
    this.element.classList.add(this.hiddenClassValue)
    window.setTimeout(() => this.element.remove(), 300)
  }
}
